import {useRoutes} from 'react-router-dom';
import {passportsRoutes} from "../features/passports/routes";

const routes = [
    ...passportsRoutes
];

export const RootRouter = () => useRoutes(routes);
